// extracted by mini-css-extract-plugin
var _1 = "'Nunito Sans'";
var _2 = "PerkList_iconContainer__jIeFW";
var _3 = "768px";
var _4 = "PerkList_perkDescription__Dz9aC";
var _5 = "PerkList_perkList__-zTRD";
var _6 = "PerkList_perkListContainer__zmoy8";
var _7 = "PerkList_perkTitle__Xhovg";
var _8 = "'../shared.module.css'";
var _9 = "PerkList_termsLink__1P+b+";
var _a = "PerkList_wrapper__hCwZV";
export { _1 as "fontNunitoSans", _2 as "iconContainer", _3 as "md", _4 as "perkDescription", _5 as "perkList", _6 as "perkListContainer", _7 as "perkTitle", _8 as "shared", _9 as "termsLink", _a as "wrapper" }
